import styled from "styled-components";


export const TextEllipsis = styled.div`
  width: 15ch;
  font-size: 16px;
  font-family: Verizon NHG eDS;
  font-weight: bold;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

